var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#43E0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#43E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.085 48C75.7536 48 48 75.9582 48 110.546C48 138.194 65.7827 161.598 90.452 169.881C93.5363 170.504 94.6661 168.536 94.6661 166.88C94.6661 165.43 94.5644 160.459 94.5644 155.281C77.2939 159.009 73.6974 147.825 73.6974 147.825C70.9219 140.576 66.8095 138.713 66.8095 138.713C61.1569 134.881 67.2213 134.881 67.2213 134.881C73.4915 135.296 76.7817 141.302 76.7817 141.302C82.3314 150.828 91.2742 148.136 94.872 146.479C95.3854 142.44 97.0311 139.645 98.7785 138.092C85.004 136.642 70.5114 131.257 70.5114 107.232C70.5114 100.398 72.9769 94.8059 76.8834 90.4571C76.267 88.9041 74.1079 82.4827 77.501 73.888C77.501 73.888 82.7432 72.2309 94.5631 80.3083C99.6237 78.9392 104.843 78.2427 110.085 78.2368C115.327 78.2368 120.671 78.9625 125.606 80.3083C137.427 72.2309 142.669 73.888 142.669 73.888C146.062 82.4827 143.902 88.9041 143.285 90.4571C147.295 94.8059 149.659 100.398 149.659 107.232C149.659 131.257 135.166 136.537 121.289 138.092C123.551 140.059 125.503 143.786 125.503 149.689C125.503 158.077 125.401 164.808 125.401 166.878C125.401 168.536 126.532 170.504 129.615 169.883C154.284 161.597 172.067 138.194 172.067 110.546C172.169 75.9582 144.314 48 110.085 48Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a7444b79e736516b3ed0c8b76ac816fd.svg";
export { ForwardRef as ReactComponent };